import { Component, inject } from '@angular/core';
import { CacTableComponent, formBuilder, table } from '@controladad/ng-base';
import { AttributeSetApiService, AuthStore, cacTableIdCol } from '@core';
import { formControl, Validators } from '@al00x/forms';
import { switchMap } from 'rxjs';
import { AttributeSetEntity } from '@models';

@Component({
  selector: 'lib-attribute-set',
  imports: [CacTableComponent],
  templateUrl: './attribute-set.component.html',
  styleUrl: './attribute-set.component.scss',
})
export class AttributeSetComponent {
  private readonly attributeApi = inject(AttributeSetApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.attributeApi.getAdapter(),
    view: {
      itemName: 'Attribute Set',
    },
    columns: {
      id: cacTableIdCol(),
      name: { label: 'Name' },
    },
    actions: [
      {
        type: 'icon' as const,
        content: 'edit',
        action: (attributeSet: AttributeSetEntity) => dialog$.attributeSet({ attributeSet }).afterSubmit(),
      },
      ...(!this.authStore.isRestrictedAdmin() ? [{
        type: 'icon' as const,
        content: 'trash',
        action: (item: AttributeSetEntity) =>
          dialog$.deletePrompt(false, { itemName: item.name }).action(() => this.attributeApi.delete(item.id)),
      }] : []),
    ],

    events: { add: () => dialog$.attributeSet({}).afterSubmit() },
  });
}
